module.exports = __webpack_public_path__ + "static/media/Simon_Lycett_getty_tablet.701d0fe0.jpg";